export default pageTitle => {
  return pageTitle + " - M&S Loan";
};
